// Single source of truth for metric display labels and aggregation policy.
// Keep this in sync with the metric_type values inserted by the data import
// pipeline (services/dynamic-schema/routes/data.js).
//
// Used by:
//   - pages/analytics/VisualItemCreator.jsx (preview)
//   - pages/analytics/SavedVisuals.jsx      (dashboard cards)
//   - pages/DashboardPage.jsx               (pinned cards)
//   - components/visuals/VisualPreview.jsx  (re-usable mini viz)
//   - components/ChartComponent.jsx         (uses COUNT_LIKE_METRICS)

export const METRIC_LABELS = {
  malaria_incidence: 'Malaria Incidence',
  flu_incidence: 'Flu Syndrome Incidence',
  flu_incidence_revised: 'Flu Syndrome (Revised)',
  pneumonia_incidence: 'Pneumonia Incidence',
  diarrhea_cases: 'Diarrheal Disease Cases',
  temperature_max: 'Maximum Temperature (Tmax)',
  temperature_min: 'Minimum Temperature (Tmin)',
  rainfall: 'Rainfall',
  relative_humidity: 'Relative Humidity (RH)',
  specific_humidity: 'Specific Humidity (SH)',
  lst_day: 'Land Surface Temp Day',
  lst_night: 'Land Surface Temp Night',
  mean_radiant_temp: 'Mean Radiant Temp (MRT)',
  utci: 'UTCI',
  cape: 'CAPE',
  surface_pressure: 'Surface Pressure (SP)',
  surface_latent_heat_flux: 'SLHF',
  surface_sensible_heat_flux: 'SSHF',
  surface_thermal_radiation: 'STRD',
  surface_solar_radiation: 'SSRD',
  spei: 'SPEI',
  zonal_wind: 'Zonal Wind (U)',
  meridional_wind: 'Meridional Wind (V)',
  vertical_velocity: 'Vertical Velocity (W)',
  pm25: 'PM2.5',
  carbon_monoxide: 'Carbon Monoxide (CO)',
  nitrogen_dioxide: 'Nitrogen Dioxide (NO2)',
  ozone: 'Ozone (O3)',
  sulfur_dioxide: 'Sulfur Dioxide (SO2)',
  formaldehyde: 'Formaldehyde (HCHO)',
  ndvi: 'NDVI',
  ndwi: 'NDWI',
  evi: 'EVI',
  chlorophyll_index: 'Chlorophyll Index (CI)',
  reci: 'RECI',
}

// Disease metrics that aggregate naturally as sums (incidence reports).
// Everything else (climate measurements, indices) aggregates as means.
export const COUNT_LIKE_METRICS = new Set([
  'diarrhea_cases',
  'flu_incidence',
  'flu_incidence_revised',
  'malaria_incidence',
  'pneumonia_incidence',
])

export const labelFor = (metricType) =>
  METRIC_LABELS[metricType] || (metricType ? metricType.replace(/_/g, ' ') : 'Value')

export const isCountLike = (metricType) =>
  metricType ? COUNT_LIKE_METRICS.has(metricType) : false
